import _ from "lodash";
import { isEmptyVal } from '@/utils';
import { defaultMapper, getCartInfo } from '@/common/service/default-mapper';
import {
  BILLING_CYCLE,
  billingCycleDependBasePlanTypeList, BillingCycleEnum,
  dependMeetingPlanTypeList,
  EventSaasConsumptionCategory,
  licenseDependBasePlanTypeList,
  planTypes,
} from '@/common/constants';
import { EventParentCategoryCode } from '@/plans/EVENT_SAAS/helper/constant';
import { getConsumptionCode } from '@/plans/EVENT_SAAS/helper/parse';

export const ConsumptionCodes = [];

export const EventSaasCategories = [
  'eventsaas100',
  'eventsaas500',
  'eventsaas1000',
  'eventsaas3000',
  'eventsaas5000',
  'eventsaas10000',
  'ze_consumption_price_list',
  'ze_only_overage_price_list',
];

export function isEventSassPlan(planType = '') {
  return EventSaasCategories.includes(planType);
}

export const ConsumptionAttendees = [50, 100, 600, 1000, 3000, 5000, 10000];

export default (planMapJSON) => {
  return EventSaasCategories.reduce((pre, key) => {
    const categoryValue = planMapJSON[key];
    const type = planTypes.EVENT_SAAS;
    const typeNameKey = 'billing.planform.title.zoom_events';

    if (isEmptyVal(categoryValue)) {
      return pre;
    }

    // consumption plan
    if (categoryValue[EventSaasConsumptionCategory]) {
      const billing_cycle = BILLING_CYCLE.PAY_PER_ATTENDEE;
      const {
        yearly_plan_code,
        prices,
      } = categoryValue[EventSaasConsumptionCategory];

      if (yearly_plan_code) {
        if (!ConsumptionCodes.includes(yearly_plan_code)) {
          ConsumptionCodes.push(yearly_plan_code);
        }

        const getPriceByAttendees = (attendees) => {
          const priceStep = prices.find(item => item.start <= attendees && item.end >= attendees);
          return (priceStep.price || 0) * attendees;
        };

        const consumptionList = ConsumptionAttendees.map(attendees => ({
          type,
          typeNameKey,
          planNameKey: 'billing.planform.title.eventsaas_consumption',
          min: 1,
          max: 1,
          billing_cycle,
          capacity: attendees,
          category: `${EventSaasConsumptionCategory}${attendees}`,
          plan_code: getConsumptionCode(yearly_plan_code, attendees),
          cartInfo: getCartInfo(),
          amount: getPriceByAttendees(attendees),
          parent_category: EventParentCategoryCode,
          billingCycleDependBasePlanTypeList,
          licenseDependBasePlanTypeList,
          dependBasePlanTypeList: dependMeetingPlanTypeList,
          supportCoupon: false,
          isPPA: true,
        }));

        return [...pre, ...consumptionList];
      }

      return pre;
    }

    // saas planList
    const planList = _.chain(defaultMapper(planMapJSON[key], type))
      .map(item => {
        return ({
          ...item,
          typeNameKey,
          planNameKey: 'billing.planform.title.zoom_events',
          parent_category: EventParentCategoryCode,
          capacity: planMapJSON[key]?.participants,
          isSaas: true,
          billingCycleDependBasePlanTypeList,
          licenseDependBasePlanTypeList,
          dependBasePlanTypeList: dependMeetingPlanTypeList,
        });
      })
      .filter((p) => {
        const billingCycle = p.billing_cycle;

        if (BillingCycleEnum[billingCycle] >= BillingCycleEnum[BILLING_CYCLE.QUARTERLY]) {
          return true;
        } else if (p.capacity === 100 && billingCycle === BILLING_CYCLE.MONTHLY) {
          return true;
        }

        return false;
      })
      .value();

    // saas plan list
    return [
      ...pre,
      ...planList,
    ];
  }, []);
}
